module.exports = __webpack_public_path__ + "img/poster_white_text.da2ad46c.png";